import { useState } from "react";

import useCsvUploader from "./csvUploader";

import { bomProductsFieldOptions } from "../../helpers/components/products";

const knownFields = [
  { header: "product_sku", field: "sku" },
  { header: "sku", field: "sku" },
  { header: "item description", field: "name" },
  { header: "product name", field: "name" },
  { header: "supplier name", field: "supplierName" },
  { header: "supplier code", field: "supplierCode" },
  { header: "supplier physical address", field: "supplierAddress" },
  { header: "factory code", field: "factoryCode" },
  { header: "factory physical address", field: "factoryAddress" },
  { header: "contact_name", field: "contactName" },
  { header: "contact name", field: "contactName" },
  { header: "contact_email", field: "contactEmail" },
  { header: "contact email", field: "contactEmail" },
  { header: "secondary_contact", field: "secondaryContact" },
  { header: "secondary contact", field: "secondaryContact" },
  { header: "category", field: "category" },
  { header: "subcategory", field: "subcategory" },
  { header: "description", field: "description" }
];

const useBomProductsCsvUploader = ({ setOpen }) => {
  const [fileInfo, setFileInfo] = useState({});
  const [matchedHeaders, setMatchedHeaders] = useState([]);

  const fieldValidator = (headers) => {
    const fields = headers.map(({ field }) => field);

    if (!fields.includes("supplierName")) {
      return {
        success: false,
        message:
          'A "Supplier Name" column is required. Please map it before continuing.'
      };
    }

    if (!fields.includes("name")) {
      return {
        success: false,
        message:
          'A "Product Name" column is required. Please map it before continuing.'
      };
    }

    if (!fields.includes("sku")) {
      return {
        success: false,
        message: 'A "SKU" column is required. Please map it before continuing.'
      };
    }

    return { success: true };
  };

  const requiredFields = bomProductsFieldOptions.filter(
    ({ required }) => required
  );

  return useCsvUploader({
    knownFields,
    fieldOptions: bomProductsFieldOptions,
    setOpen,
    fileInfo,
    setFileInfo,
    matchedHeaders,
    setMatchedHeaders,
    fieldValidator,
    docType: "bom-products",
    title: "Import Supplier Products",
    firstStepText:
      "Upload a CSV of your supplier product list to create products and link them to your vendors.",
    requiredFields
  });
};

export default useBomProductsCsvUploader;
